<template>
  <div class="personal-data">
    <div class="w-full">
      <router-link class="font-bold flex items-center text-primary" :to="{ name: 'book-table' }">
        <svg
          width="20px"
          height="20px"
          class="caret-left-icon svg-primary"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 256 256"
        >
          <path
            d="M160,216a7.97482,7.97482,0,0,1-5.65674-2.343l-80-80a7.99973,7.99973,0,0,1,0-11.314l80-80a8,8,0,0,1,11.31348,11.314L91.314,128l74.34278,74.343A8,8,0,0,1,160,216Z"
          />
        </svg>

        {{ $t("wizard.back") }}</router-link
      >
    </div>
    <h3 class="text-primary text-center mt-8">{{ $t("wizard.book_table") }}</h3>
    <p class="text-primary text-center underline">{{ $t("wizard.address") }}</p>

    <div class="form-container">
      <p class="font-bold">{{ $t("wizard.title_form") }}</p>
      <v-app>
        <v-form
          ref="form"
          class="mt-6"
          v-model="valid"
          lazy-validation
          @submit.prevent="submitData"
        >
          <v-text-field
            v-model="name"
            :rules="nameRules"
            :label="$t('wizard.form.name')"
            required
            outlined
            color="black"
            autocomplete="off"
          ></v-text-field>
          <v-text-field
            v-model="phone"
            :rules="phoneRules"
            :label="$t('wizard.form.phone')"
            required
            outlined
            color="black"
            autocomplete="off"
          ></v-text-field>
          <v-text-field
            v-model="email"
            :rules="emailRules"
            :label="$t('wizard.form.email')"
            required
            outlined
            color="black"
            autocomplete="off"
          ></v-text-field>
          <v-textarea
            v-model="observations"
            :label="$t('wizard.form.observations')"
            required
            outlined
            rows="3"
            color="black"
          ></v-textarea>

          <button
            class="btn btn-outline-primary w-full flex justify-center mb-10 mx-auto"
            :class="{ disabled: loading }"
            v-ripple
          >
            <span v-if="!loading">{{ $t("wizard.comfirm_button") }}</span>
            <v-progress-circular
              v-else
              indeterminate
              color="rgba(0,0,0,.26)"
            ></v-progress-circular>
          </button>
        </v-form>
      </v-app>
    </div>
    <v-snackbar v-model="error" color="#F44336">{{
      $t(snackbarText)
    }}</v-snackbar>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import axios from "axios";
export default {
  data() {
    return {
      snackbarText: "wizard.form.error",
      valid: false,
      error: false,
      nameRules: [(v) => !!v || this.$t("wizard.form.name_required")],
      emailRules: [
        (v) => !!v || this.$t("wizard.form.email_required"),
        (v) => /.+@.+\..+/.test(v) || this.$t("wizard.form.email_valid"),
      ],
      phoneRules: [
        (v) => !!v || this.$t("wizard.form.phone_required"),
        (v) => /^\d{9}$/.test(v) || this.$t("wizard.form.phone_valid"),
      ],
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      wizard: "getWizard",
    }),
    name: {
      get() {
        return this.$store.getters["getName"];
      },
      set(value) {
        this.setName(value);
      },
    },
    email: {
      get() {
        return this.$store.getters["getEmail"];
      },
      set(value) {
        this.setEmail(value);
      },
    },
    phone: {
      get() {
        return this.$store.getters["getPhone"];
      },
      set(value) {
        this.setPhone(value);
      },
    },
    observations: {
      get() {
        return this.$store.getters["getObservations"];
      },
      set(value) {
        this.setObservations(value);
      },
    },
    wizardPrepared() {
      return {
        ...this.wizard,
        date: this.wizard.date.split("T")[0],
      };
    },
  },
  methods: {
    ...mapMutations(["setName", "setPhone", "setEmail", "setObservations"]),
    submitData(event) {
      if (!this.$refs.form.validate() || this.loading) return;
      this.loading = true;
      axios
        .post("/api/reservation", {
          name: this.wizard.name,
          email: this.wizard.email.trim(),
          phone: this.wizard.phone,
          locale: window.appLocale,
          wizard: JSON.stringify(this.wizardPrepared),
        })
        .then((res) => {
          if (res.data.error) {
            this.snackbarText = this.$t('wizard.something_went_wrong');
            this.error = true;
            return;
          }
          this.$router.push({ name: "comfirmed" });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == "comfirmed") {
        window.location.replace("/");
        return next(false);
    }

    next();
  },
};
</script>

<style lang="scss">
.personal-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .form-container {
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 328px;

    button {
      outline: none;
    }
  }
}

.svg-primary{
  fill: #9a1f35;
}
</style>
